import React from "react";

//components
import Card from "../../ui/Card/Card";
import { IRoleListProps, IRoleItemProps } from "./module/constants";

//styles
import classes from "./RolesList.module.scss";

const RolesList = (props: IRoleListProps) => {
  const { roles, onClick, selected } = props;

  return (
    <React.Fragment>
      <div className={classes.list}>
        {roles.map((itemData: IRoleItemProps, i: number) => (
          <Card
            key={i}
            onClickFunction={() => onClick && onClick(itemData)}
            selected={
              selected && selected.role && selected.role === itemData.role
                ? true
                : false
            }
            disabled={!itemData.delegationAllowed}
          >
            <div className="row">
              <div className="col-12 d-flex justify-content-left">
                {itemData.role}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </React.Fragment>
  );
};

export default RolesList;
